/*
 * Copyright (c) 2019 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

import axiosInstance from "./ForgeAxiosInstance";
import DIYAppConstants from "../../utils/DIYAppConstants";
import { action, observable } from "mobx";
import GlobalStore from "../GlobalStore/GlobalStore";
import featureFlagStore from '../../utils/FeatureFlags/APFeatureFlagsStore';
import { Gateway } from "../../components/VirtualGateway/GatewayList/GatewayList";


/**
 * This store retrives the list of sites that the user has access to
 */
export default class GatewayIdentityStore extends GlobalStore
{

    @observable sitesLoaded: boolean = false

    simplyConnectCallSuccess = false;
    constructor()
    {
        super();
    }

    getSiteList = () =>
    {
        let envVariables = this.envVariables;
        let gatewayListURL = `${envVariables.PORTAL_API_GATEWAY_URL}${DIYAppConstants.API_SITE_FOR_USER_AUTH_GROUP}`;
        let instance = axiosInstance.getInstance();
        return instance.get(gatewayListURL);
    }

    @action
    getGatewayListBySiteId = async (siteId: string) =>
    {
        return this.getAllGatewayListBySiteId(siteId).then((response: any) =>
        {
            return response;
        });
    };
    /**
     * API call to fetch gateway list by sideId
     * @param siteId 
     */
    private getAllGatewayListBySiteId = (siteId: string): any =>
    {
        let envVariables = this.envVariables;
        let gatewayListURL;
        if(featureFlagStore.getGatewayAzureProvisioningForSite && featureFlagStore.getGatewayAzureProvisioningEnabled)
           gatewayListURL = `${envVariables.CAAS_FCS_BASE_API_URL}`+'/v2/customer/site/'+siteId;
        else
           gatewayListURL = `${envVariables.GATEWAY_MANAGEMENT_BASE_API_URL}${DIYAppConstants.GATEWAY_LIST_BY_SITE_ID}` + siteId;

        return axiosInstance.getInstance()({
            url: gatewayListURL,
            method: 'GET',
            headers: { 'organizationId': siteId }
        }).catch(() =>
        {
            //do not perform any action if this call fails
        });
    }
    /**
       * Check if the site type is `Intelligent Gateway`.
       * Gateway registration can only happen for sites of type "Intelligent Gateway"
       */
    fetchIdentityPackage = (serialNo: string, organizationId: string, gateway: Gateway): Promise<any> =>
    {
        let envVars = this.envVariables;
        let downloadURL = `${envVars.GATEWAY_MANAGEMENT_BASE_API_URL}${GatewayIdentityStore.IDENTITY_CONTENT_API(serialNo)}`;
        
        
        if(gateway.providerName===DIYAppConstants.PROVIDER_NAME_AZURE){
            downloadURL = `${envVars.CAAS_FCS_BASE_API_URL}`+'/v2/customer/'+gateway.customerId+'/gateways/'+gateway.gatewayId+'/identity'
        }

        return axiosInstance.getInstance()({
            url: downloadURL,
            method: 'GET',
            headers: {
                'organizationid': organizationId,
                'fc-kong-api-key': `${envVars.FC_KONG_API_KEY}`
            }
        });
    }

    public static readonly IDENTITY_CONTENT_API = (serialNo: string) => `/api/v1/gateway/identity/${serialNo}`;
    public static readonly IDENTITY_ERROR_CONTENT = "--ERROR GENERATING IDENTITY--";

    /**
     * Fetch list of SimplyConnect clients
     */
    getSimplyConnectClients = async (ids: string[], organizationId: string): Promise<any> =>
    {
        var clientIds = ids.join(",");
        var envVariables = this.envVariables;
        var getClientsApiUrl =`${envVariables.SIMPLYCONNECT_API_URL}${DIYAppConstants.SC_API_GET_CLIENT(clientIds)}`;

        return axiosInstance.getSimplyConnectInstance()
        (
            {
                url: getClientsApiUrl,
                headers: { 'OrganizationId': organizationId },
                method: 'GET'
            }
        );
    }
    /**
     * Fetch one SimplyConnect client
     */
    getSimplyConnectClient = async (deviceId: string, organizationId: string): Promise<any> =>
    {
        var systemId = this.envVariables.SIMPLYCONNECT_SYSTEM_ID;
        var clientId = systemId + '-' + deviceId;
        var envVariables = this.envVariables;
        var getClientApiUrl = `${envVariables.SIMPLYCONNECT_API_URL}${DIYAppConstants.SC_API_GET_CLIENT(clientId)}`;

        return axiosInstance.getSimplyConnectInstance()
        (
            {
                url: getClientApiUrl,
                headers: { 'OrganizationId': organizationId },
                method: 'GET'
            }
        );
    }

     /**
     * Upload CSR
     */
     uploadCsr = async (csrContent: string, deviceId: string, organizationId: string): Promise<any> =>
     {
         var encodedCsr = Buffer.from(csrContent).toString('base64');
         var envVariables = this.envVariables;
         var uploadCsrApiUrl = `${envVariables.SIMPLYCONNECT_API_URL}${DIYAppConstants.SC_API_UPLOAD_CSR}`;
         var json = '{ "csrContent": "' + encodedCsr + '", "deviceId": "' + deviceId + '" }';
 
         return axiosInstance.getSimplyConnectInstance()
         (
             {
                 url: uploadCsrApiUrl,
                 headers: { 'OrganizationId': organizationId },
                 method: 'POST',
                 data: json
             }
         );
     }

    /**
     * Upload CSR
     */
    uploadConfig = async (config: string, deviceId: any, organizationId: string, customerId: any): Promise<any> =>
    {
        var envVariables = this.envVariables;
        var uploadConfigURL = `${envVariables.CAAS_FCS_BASE_API_URL}/v2/customer/`+customerId+`/gateways/`+deviceId+`/configuration`;
        var json = '{ "gatewayConfig": "' + config + '" }';

        return axiosInstance.getInstance()
        (
            {
                url: uploadConfigURL,
                headers: { 'OrganizationId': organizationId },
                method: 'POST',
                data: json
            }
        );
    }
}
